import { all, call, put, throttle } from 'redux-saga/effects';
import { request } from '../../xhr';
import { searchFailure, searchSuccess, searchTags } from './actions';
function* apiSearch(query) {
    return yield call(request, {
        method: 'get',
        url: '/tags/search',
        params: {
            query
        }
    }, ()=>({
            tags: [
                {
                    name: 'Obi-wan Kenobi'
                },
                {
                    name: 'Luke Skywalker'
                },
                {
                    name: 'Leia Organa'
                }
            ].filter(({ name  })=>name.toLowerCase().includes(query.toLowerCase()))
        }));
}
function* handleSearchTags(action) {
    if (!action.payload.query) {
        return;
    }
    const response = yield apiSearch(action.payload.query);
    if (!response || response.error) {
        yield put(searchFailure());
        return;
    }
    yield put(searchSuccess(response.tags.map(({ name  })=>name)));
}
export default function* tagInputSaga() {
    yield all([
        throttle(250, searchTags, handleSearchTags)
    ]);
}
